import moment from 'moment';
import { h } from 'ui/Framework';
import * as H from 'ui/Framework/Hooks';
import DatePicker from 'datepicker';


const DATE_FORMAT = 'YYYY-MM-DD';

const DatePickerHook = H.makeHook((el, datePicker, _prevOnChange, onChange) => {
  if (el) {
    if (!datePicker) {
      datePicker = DatePicker.create({
        field: el,
        container: el.parentElement,
        yearRange: [1900, moment().add(10, 'years').year()],
        onSelect: function () {
          onChange(this.getMoment().format(DATE_FORMAT));
        },
        firstDay: 1,
        theme: 'search__datepicker'
      });
    }
    return datePicker;
  } else if (datePicker) {
    datePicker.destroy();
  }
});

export default function filterValueDate ({ testId, value, inputRef, onChange, onKeyDown }) {
  const formattedDate = getFormattedDate(value);

  return h('div', {
    style: {
      position: 'relative',
      display: 'flex',
      width: getWidth(formattedDate)
    }
  }, [
    h('input.input-reset.search__input-text', {
      dataTestId: testId,
      hooks: [DatePickerHook(onChange), H.Ref(el => el && inputRef(el))],
      onKeyDown,
      value: formattedDate,
      tabIndex: '0',
      style: {
        width: getWidth(formattedDate),
        paddingLeft: '10px'
      },
      readOnly: true
    })
  ]);
}

function getFormattedDate (value) {
  let date = '';
  if (value) {
    date = moment(value, moment.ISO_8601).format(DATE_FORMAT);
  }
  return date;
}

function getWidth (value) {
  if (value) {
    return `calc(${value.length}ch + 20px)`;
  } else {
    return '100px';
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/app/ContentList/Search/ValueInput/Date.es6.js